import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const toLocalTime = utcTime => {
  if (!utcTime) return null;
  return dayjs.utc(utcTime).local();
};

export const formatDate = (dateString, format = 'DD-MM-YYYY') => {
  if (!dateString) return '---';
  return toLocalTime(dateString).format(format);
};

export const formatDateTime = (dateString, format = 'DD MMM YYYY, h:mm A') => {
  if (!dateString) return '---';
  return toLocalTime(dateString).format(format);
};

export const formatDateLong = dateString => {
  if (!dateString) return '---';
  return toLocalTime(dateString).format('DD MMM, YYYY');
};

export const formatDateWithTime = (dateString, format = 'dddd h:mma') => {
  if (!dateString) return '---';
  return toLocalTime(dateString).format(format);
};

export const formatDateShort = dateString => {
  if (!dateString) return '---';
  return toLocalTime(dateString).format('DD MMM YYYY');
};

export const formatDateFull = dateString => {
  if (!dateString) return '---';
  return toLocalTime(dateString).format('D MMMM, h:mm A');
};

export const formatTimeFromUTC = timeString => {
  if (!timeString) return '';

  const today = dayjs().format('YYYY-MM-DD');
  const utcDateTime = `${today}T${timeString}:00Z`;

  const localTime = dayjs.utc(utcDateTime).local();

  return localTime.format('h:mm A');
};
